
import Vue from "vue";
import Component from "vue-class-component";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import { CreateTruckRequest } from "../models/api/trucks/createTrucks";
import notifications from "../lib/notifications";
import Select from "../components/form/Select.vue";
const truckModuleState = getModule(TruckModule);

@Component({
  components: {
    Select
  }
})
export default class NewTruck extends Vue {
  newTrucks: AddTruckViewModel[] = [this.defaultTruck()];
  lastTruck: AddTruckViewModel = null;
  saving: boolean = false;
  drivers: any[] = null;

  async created() {}

  get invalid() {
    return this.newTrucks.filter(x => x.added).length < 1;
  }

  resetModal() {}

  async submit() {
    this.saving = true;
    let hasErrors: boolean = false;

    for (let x = 0; x < this.newTrucks.filter(x => x.added).length; x++) {
      const truckToSave = this.newTrucks[x];
      try {
        const truckRequest: CreateTruckRequest = {
          truckName: truckToSave.truckName,
          deliveryDate: truckToSave.deliveryDate,
          driverId: truckToSave.driver,
          tripDays: +truckToSave.tripDays,
          maxCubes: +truckToSave.maxCubes,
          zipsServed: truckToSave.zipsServed.join(","),
          facilityCode: truckToSave.facilityCode
        };

        const response = await truckModuleState.createTruck(truckRequest);
      } catch (ex) {
        hasErrors = true;
      }
    }

    this.saving = false;

    if (!hasErrors) {
      this.$router.push({ path: "/trucks" });
    }
  }

  add(truck) {
    truck.added = true;

    this.lastTruck = truck;

    this.newTrucks.push(this.defaultTruck());
  }

  defaultTruck(): AddTruckViewModel {
    const newTruckId = this.newTrucks ? this.newTrucks.length + 1 : 1;

    let newTruck = {
      id: newTruckId,
      added: false,
      maxCubes: 1100,
      tripDays: 1,
      availableDrivers: [],
      driver: null,
      facilityCode: null,
      deliveryDate: null
    };

    if (this.lastTruck) {
      newTruck.maxCubes = this.lastTruck.maxCubes;
      newTruck.facilityCode = this.lastTruck.facilityCode;
      newTruck.deliveryDate = this.lastTruck.deliveryDate;
    }

    return newTruck;
  }

  remove(truck) {
    const truckIndex = this.newTrucks.findIndex(x => x.id === truck.id);

    this.newTrucks.splice(truckIndex, 1);
  }

  async updateDrivers(model: AddTruckViewModel) {
    try {
      const response = await truckModuleState.getDrivers({ facilityCode: model.facilityCode });
      model.availableDrivers = response.map(x => ({ label: x.driverName, value: x.id }));
    } catch (ex) {
      notifications.error("Driver List", "Failed to load driver list", ex);
    }
  }
}

interface AddTruckViewModel {
  id: number;
  truckName?: string;
  deliveryDate?: Date;
  zipsServed?: string[];
  driver: number | null;
  maxCubes?: number;
  tripDays?: number;
  facilityCode?: string;
  added: boolean;
  availableDrivers: any[];
}
